import { Injectable } from '@angular/core';
import { CommonUtils } from '../../../../shared/utils/common.utils';

@Injectable()
export class DocumentService {
  getDocumentTypeBy(extension: string): string {
    switch (extension.toLowerCase()) {
      case 'pdf':
        return 'application/pdf';
      case 'png':
        return 'image/png';
      case 'jpeg':
      case 'jpg':
        return 'image/jpeg';
      case 'tiff':
        return 'image/tiff';
      case 'txt':
        return 'text/plain';
      case 'docx':
        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      case 'xlsx':
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      default:
        return '';
    }
  }

  download(file: Blob, fileName: string): void {
    const fileExtension = CommonUtils.getExtension(fileName);
    if (this.shouldDownload(fileExtension)) {
      const fileUrl = URL.createObjectURL(file);
      const a: HTMLAnchorElement = document.createElement(
        'a'
      ) as HTMLAnchorElement;
      a.href = fileUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(fileUrl);
    } else {
      const tab = window.open();
      const fileUrl = URL.createObjectURL(file);
      tab.location.href = fileUrl;
    }
  }

  private shouldDownload(fileExtension: string): boolean {
    if (
      fileExtension.toLowerCase() === 'txt' ||
      fileExtension.toLowerCase() === 'docx' ||
      fileExtension.toLowerCase() === 'xlsx'
    ) {
      return true;
    }
    return false;
  }
}
